import type { FilterField, SelectFilterField } from '@/components/common/AdvancedFilter';
import { toFilterOptions } from '@/utils/filters';
import {
  APPROVE_STATUS_OPTIONS,
  VERIFY_STATUS,
  WORK_TYPE_OPTIONS,
} from '../constants/billing.constants';

interface NamedOption {
  id: number;
  name: string;
}

const VERIFY_STATUS_OPTIONS: NamedOption[] = [
  { id: VERIFY_STATUS.PENDING, name: 'Pending' },
  { id: VERIFY_STATUS.VERIFIED, name: 'Verified' },
  { id: VERIFY_STATUS.REJECTED, name: 'Rejected' },
];

export function getVerifyStatusFilterField(): FilterField {
  return {
    key: 'isVerify',
    label: 'Status',
    type: 'select',
    options: toFilterOptions(VERIFY_STATUS_OPTIONS),
    isClearable: false,
  };
}

interface ApprovalStatusFieldOptions {
  isClearable?: boolean;
  label?: string;
}

export function getApprovalStatusFilterField({
  isClearable = true,
  label = 'Status',
}: ApprovalStatusFieldOptions = {}): SelectFilterField {
  return {
    key: 'approveTypeNo',
    label,
    type: 'select',
    placeholder: 'All Approval States',
    options: toFilterOptions(APPROVE_STATUS_OPTIONS),
    isClearable,
  };
}

export function getWorkTypeFilterField(): FilterField {
  return {
    key: 'dcrTypeId',
    label: 'Work Type',
    type: 'select',
    placeholder: 'All Work Types',
    options: toFilterOptions(WORK_TYPE_OPTIONS),
  };
}

export function getExpenseTypeFilterField(expenseTypes: NamedOption[] | undefined): FilterField {
  return {
    key: 'expenseTypeId',
    label: 'Expense Type',
    type: 'select',
    placeholder: 'All Expense Types',
    options: toFilterOptions(expenseTypes),
    searchable: true,
  };
}

export function getDesignationFilterField(designations: NamedOption[] | undefined): FilterField {
  return {
    key: 'designationId',
    label: 'User Designation',
    type: 'select',
    placeholder: 'All Designations',
    options: toFilterOptions(designations),
    searchable: true,
  };
}

export function getMinAmountFilterField(key: string, label: string): FilterField {
  return { key, label, type: 'number', placeholder: 'Any amount' };
}

export function getMinCostFilterField(): FilterField {
  return getMinAmountFilterField('minAmount', 'Cost (Tk), more than');
}
